/* eslint-disable import/prefer-default-export, max-len, no-void */
import { isEmpty, forEach } from 'lodash';
import { convertValuByUnit } from '@/utils/number';
import { calcUptime } from '@/utils/date';
import { Q, MapUtil } from '@/views/topologymap/js/maps';

/**
 * [getInterfaceLabel description]
 * @author {name}
 * @param  {[type]} dir    [description]
 * @param  {[type]} data   [description]
 * @param  {[type]} target [description]
 * @return {[type]}        [description]
 */
function getInterfaceLabel(dir, data, target) {
  const model = target.get('model');

  return MapUtil.getInterfaceLabel(data[`${dir}IfAlias`], data[`${dir}IfName`], data[`${dir}IfDesc`], model.lineOptions.showIfLabelCombobox);
}

/**
 * 회선 툴팁
 * @author {name}
 * @param  {[type]} tipData [description]
 * @param  {[type]} target  [description]
 */
function setLanModelToolTipText(tipData, target) {
  let tipText = ' ';
  if (!isEmpty(tipData.srcIfName) && !isEmpty(tipData.dstIfName)) {
    tipText = `
      <div class="object-tooltip">
        <div class="inner-contents">
          <div class="tooltip-header">
            <label class="name">인터페이스정보</label>
          </div>
          <div class="tooltip-content">
            <div class="object_info">
              <table>
                <colgroup>
                  <col width="40%">
                  <col width="60%">
                </colgroup>
                <tr><th>장비명</th><td>${tipData.srcDeviceName || tipData.srcDeviceIp} / ${tipData.dstDeviceName || tipData.dstDeviceIp}</td></tr>
                <tr><th>인터페이스명</th><td>${getInterfaceLabel('src', tipData, target)} / ${getInterfaceLabel('dst', tipData, target)}</td></tr>
                ${tipData.srcObjId > 0 && tipData.dstObjId > 0 ? `
                  <tr>
                    <th>대역폭</th>
                    <td>
                      ${convertValuByUnit(tipData.srcIfSpeed, 'bps', false, false, true)}bps / ${convertValuByUnit(tipData.dstIfSpeed, 'bps', false, false, true)}bps
                    </td>
                  </tr>
                  <tr>
                    <th>bps 입력</th>
                    <td>
                    ${convertValuByUnit(tipData.srcBpsIn, 'bps', false, false, true) || '-'}bps / ${convertValuByUnit(tipData.dstBpsIn, 'bps', false, false, true) || '-'}bps
                    </td>
                  </tr>
                  <tr>
                    <th>bps 출력</th>
                    <td>
                    ${convertValuByUnit(tipData.srcBpsOut, 'bps', false, false, true) || '-'}bps / ${convertValuByUnit(tipData.dstBpsOut, 'bps', false, false, true) || '-'}bps
                    </td>
                  </tr>
                ` : ''}
              </table>
            </div>
          </div>
        </div>
      </div>
    `;
  } else if (!isEmpty(tipData.srcIfName)) {
    tipText = `
      <div class="object-tooltip">
        <div class="inner-contents">
          <div class="tooltip-header">
            <label class="name">인터페이스명 : ${getInterfaceLabel('src', tipData, target)}</label>
          </div>
          <div class="tooltip-content">
            <div class="object_info">
              <table>
                <colgroup>
                  <col width="40%">
                  <col width="60%">
                </colgroup>
                <tr><th>장비명</th><td>${tipData.srcDeviceName || tipData.srcDeviceIp}</td></tr>
                ${tipData.srcObjId > 0 ? `
                  <tr>
                    <th>대역폭</th>
                    <td>
                      ${convertValuByUnit(tipData.srcIfSpeed, 'bps', false, false, true) || '-'}bps
                    </td>
                  </tr>
                  <tr>
                    <th>bps 입력</th>
                    <td>
                      ${convertValuByUnit(tipData.srcBpsIn, 'bps', false, false, true) || '-'}bps
                    </td>
                  </tr>
                  <tr>
                    <th>bps 출력</th>
                    <td>
                      ${convertValuByUnit(tipData.srcBpsOut, 'bps', false, false, true) || '-'}bps
                    </td>
                  </tr>
                ` : ''}
              </table>
            </div>
          </div>
        </div>
      </div>
    `;
  } else if (!isEmpty(tipData.dstIfName)) {
    tipText = `
      <div class="object-tooltip">
        <div class="inner-contents">
          <div class="tooltip-header">
            <label class="name">인터페이스명 : ${getInterfaceLabel('dst', tipData, target)}</label>
          </div>
          <div class="tooltip-content">
            <div class="object_info">
              <table>
                <colgroup>
                  <col width="40%">
                  <col width="60%">
                </colgroup>
                <tr><th>장비명</th><td>${tipData.dstDeviceName || tipData.dstDeviceIp}</td></tr>
                ${tipData.dstObjId > 0 ? `
                  <tr>
                    <th>대역폭</th>
                    <td>
                      ${convertValuByUnit(tipData.dstIfSpeed, 'bps', false, false, true) || '-'}bps
                    </td>
                  </tr>
                  <tr>
                    <th>bps 입력</th>
                    <td>
                      ${convertValuByUnit(tipData.dstBpsIn, 'bps', false, false, true) || '-'}bps
                    </td>
                  </tr>
                  <tr>
                    <th>bps 출력</th>
                    <td>
                      ${convertValuByUnit(tipData.dstBpsOut, 'bps', false, false, true) || '-'}bps
                    </td>
                  </tr>
                ` : ''}
              </table>
            </div>
          </div>
        </div>
      </div>
    `;
  }
  return tipText;
}

/**
 * 공통 오브젝트 툴팁
 * @author {name}
 * @param  {[type]} tipData [description]
 */
function setCommonToolTipText(tipData) {
  const tipText = `
  <div class="object-tooltip">
    <div class="inner-contents">
      <div class="tooltip-header">
        <label class="name">${tipData.objName}</label>
      </div>
      <div class="tooltip-content">
        <div class="object_info">
          <table>
            <colgroup>
              <col width="40%">
              <col width="60%">
            </colgroup>
            ${!isEmpty(tipData.objtypeName) ? `<tr><th>장비종류</th><td>${tipData.objtypeName}</td></tr>` : ''}
            ${!isEmpty(tipData.objCompanyName) ? `<tr><th>제조사</th><td>${tipData.objCompanyName}</td></tr>` : ''}
            ${!isEmpty(tipData.objProductId) ? `<tr><th>모델명</th><td>${tipData.objProductId}</td></tr>` : ''}
            ${!isEmpty(tipData.ipaddress) ? `<tr><th>IP</th><td>${tipData.ipaddress}</td></tr>` : ''}
          </table>
        </div>
        <div class="object_info" style="margin-top: 10px;">
          <table>
            <colgroup>
              <col width="40%">
              <col width="60%">
            </colgroup>
            ${!isEmpty(tipData.registDatetime) ? `<tr><th>장비등록 일</th><td>${tipData.registDatetime}</td></tr>` : ''}
            ${!isEmpty(tipData.totalCount) ? `<tr><th>인터페이스 정보</th><td>전체 : ${tipData.totalCount}(운영 : ${tipData.normalCount} 미운영 : ${tipData.totalCount - tipData.normalCount})</td></tr>` : ''}
            ${!isEmpty(tipData.majorManagerName) ? `<tr style="border-top:1px solid #d6dae1"><th>관리자 (정)</th><td>${!isEmpty(tipData.majorManagerName) ? tipData.majorManagerName : '-'}(${!isEmpty(tipData.majorTelNumber) ? tipData.majorTelNumber : '-'})</td></tr>` : ''}
            ${!isEmpty(tipData.minorManagerName) ? `<tr><th>관리자 (부)</th><td>${!isEmpty(tipData.minorManagerName) ? tipData.minorManagerName : '-'}(${!isEmpty(tipData.minorTelNumber) ? tipData.minorTelNumber : '-'})</td></tr>` : ''}
          </table>
        </div>
      </div>
      %PERFORMANCE%
      %MEMO%
    </div>
  </div>
  `;

  return tipText;
}

/**
 * 시설 관리대상 툴팁
 * @author {name}
 * @param  {[type]} tipData [description]
 */
function setFmsToolTipText(tipData) {
  const tipText = `
    <div class="object-tooltip">
      <div class="inner-contents">
        <div class="tooltip-header">
          <label class="name">${tipData.objName}</label>
        </div>
        <div class="tooltip-content">
          <div class="object_info">
          <table>
            <colgroup>
              <col width="40%">
              <col width="60%">
            </colgroup>
            ${!isEmpty(tipData.parentObjName) ? `<tr><th>환경감시장비</th><td>${tipData.parentObjName}</td></tr>` : ''}
            ${!isEmpty(tipData.objtypeName) ? `<tr><th>센서타입</th><td>${tipData.objtypeName}</td></tr>` : ''}
            ${!isEmpty(tipData.ipaddress) ? `<tr><th>IP</th><td>${tipData.ipaddress}</td></tr>` : ''}
          </table>
        </div>
        %PERFORMANCE%
        %MEMO%
      </div>
    </div>
  `;
  return tipText;
}

/**
 * 네트워크 관리대상 툴팁
 * @author {name}
 * @param  {[type]} tipData [description]
 * @param  {[type]} target  [description]
 */
function setNmsToolTipText(tipData, target) {
  let tipText = ' ';
  const objDefineId = target.get('objDefineId');
  const objtypeId = target.get('objtypeId');
  if (objDefineId === 'NETDEVICE') {
    tipText = `
      <div class="object-tooltip">
        <div class="inner-contents">
          <div class="tooltip-header">
            <label class="name">${tipData.objName}</label>
          </div>
          <div class="tooltip-content">
            <div class="object_info">
              <table>
                <colgroup>
                  <col width="40%">
                  <col width="60%">
                </colgroup>
                ${!isEmpty(tipData.objtypeName) ? `<tr><th>장비종류</th><td>${tipData.objtypeName}</td></tr>` : ''}
                ${!isEmpty(tipData.objCompanyName) ? `<tr><th>제조사</th><td>${tipData.objCompanyName}</td></tr>` : ''}
                ${!isEmpty(tipData.objProductId) ? `<tr><th>모델명</th><td>${tipData.objProductId}</td></tr>` : ''}
                ${!isEmpty(tipData.ipaddress) ? `<tr><th>IP</th><td>${tipData.ipaddress}</td></tr>` : ''}
                ${!isEmpty(tipData.rackLocation) ? `<tr><th>랙(위치/크기/내부)</th><td>(${tipData.rackLocation}/${tipData.deviceSize}/${tipData.deviceLocation})</td></tr>` : ''}
              </table>
            </div>
            <div class="object_info" style="margin-top: 10px;">
              <table>
                <colgroup>
                  <col width="40%">
                  <col width="60%">
                </colgroup>
                ${!isEmpty(tipData.registDatetime) ? `<tr><th>장비등록 일</th><td>${tipData.registDatetime}</td></tr>` : ''}
                ${!isEmpty(tipData.availRate) ? `<tr><th>가동률</th><td>${tipData.availRate}%</td></tr>` : ''}
                ${!isEmpty(tipData.totalCount) ? `<tr><th>인터페이스 정보</th><td>전체 : ${tipData.totalCount}(운영 : ${tipData.normalCount} 미운영 : ${tipData.totalCount - tipData.normalCount})</td></tr>` : ''}
                ${!isEmpty(tipData.majorManagerName) ? `<tr style="border-top:1px solid #d6dae1"><th>관리자 (정)</th><td>${!isEmpty(tipData.majorManagerName) ? tipData.majorManagerName : '-'}(${!isEmpty(tipData.majorTelNumber) ? tipData.majorTelNumber : '-'})</td></tr>` : ''}
                ${!isEmpty(tipData.minorManagerName) ? `<tr><th>관리자 (부)</th><td>${!isEmpty(tipData.minorManagerName) ? tipData.minorManagerName : '-'}(${!isEmpty(tipData.minorTelNumber) ? tipData.minorTelNumber : '-'})</td></tr>` : ''}
              </table>
            </div>
            %PERFORMANCE%
            %MEMO%
          </div>
        </div>
      </div>
    `;
  } else if (objDefineId === 'WIRELESS_DEVICE' && objtypeId === 'AP_CONTROLLER') {
    tipText = `
      <div class="object-tooltip">
        <div class="inner-contents">
          <div class="tooltip-header">
            <label class="name">${tipData.objName}</label>
          </div>
          <div class="tooltip-content">
            <div class="object_info">
              <table>
                <colgroup>
                  <col width="40%">
                  <col width="60%">
                </colgroup>
                ${!isEmpty(tipData.objtypeName) ? `<tr><th>장비종류</th><td>${tipData.objtypeName}</td></tr>` : ''}
                ${!isEmpty(tipData.objCompanyName) ? `<tr><th>제조사</th><td>${tipData.objCompanyName}</td></tr>` : ''}
                ${!isEmpty(tipData.ipaddress) ? `<tr><th>IP</th><td>${tipData.ipaddress}</td></tr>` : ''}
              </table>
            </div>
            <div class="object_info" style="margin-top: 10px;">
              <table>
                <colgroup>
                  <col width="40%">
                  <col width="60%">
                </colgroup>
                ${!isEmpty(tipData.registDatetime) ? `<tr><th>장비등록 일</th><td>${tipData.registDatetime}</td></tr>` : ''}
                ${!isEmpty(tipData.totalCount) ? `<tr><th>인터페이스 정보</th><td>전체 : ${tipData.totalCount}(운영 : ${tipData.normalCount} 미운영 : ${tipData.totalCount - tipData.normalCount})</td></tr>` : ''}
                ${!isEmpty(tipData.apCount) ? `<tr><th>무선 AP 수</th><td>${tipData.apCount}</td></tr>` : ''}
              </table>
            </div>
            %PERFORMANCE%
            %MEMO%
          </div>
        </div>
      </div>
    `;
  } else if (objDefineId === 'WIRELESS_DEVICE' && objtypeId === 'WIRELESSAP') {
    tipText = `
      <div class="object-tooltip">
        <div class="inner-contents">
          <div class="tooltip-header">
            <label class="name">${tipData.objName}</label>
          </div>
          <div class="tooltip-content">
            <div class="object_info">
              <table>
                <colgroup>
                  <col width="40%">
                  <col width="60%">
                </colgroup>
                ${!isEmpty(tipData.objtypeName) ? `<tr><th>장비종류</th><td>${tipData.objtypeName}</td></tr>` : ''}
                ${!isEmpty(tipData.objCompanyName) ? `<tr><th>제조사</th><td>${tipData.objCompanyName}</td></tr>` : ''}
                ${!isEmpty(tipData.ipaddress) ? `<tr><th>IP</th><td>${tipData.ipaddress}</td></tr>` : ''}
              </table>
            </div>
            <div class="object_info" style="margin-top: 10px;">
              <table>
                <colgroup>
                  <col width="40%">
                  <col width="60%">
                </colgroup>
                ${!isEmpty(tipData.registDatetime) ? `<tr><th>장비등록 일</th><td>${tipData.registDatetime}</td></tr>` : ''}
              </table>
            </div>
            %PERFORMANCE%
            %MEMO%
          </div>
        </div>
      </div>
    `;
  } else {
    tipText = `
      <div class="object-tooltip">
        <div class="inner-contents">
          <div class="tooltip-header">
            <label class="name">${tipData.objName}</label>
          </div>
          <div class="tooltip-content">
            <div class="object_info">
              <table>
                <colgroup>
                  <col width="40%">
                  <col width="60%">
                </colgroup>
                ${!isEmpty(tipData.ifName) ? `<tr><th>인터페이스명</th><td>${tipData.ifName}</td></tr>` : ''}
                ${!isEmpty(tipData.ifIndex) ? `<tr><th>인덱스</th><td>${tipData.ifIndex}</td></tr>` : ''}
                ${!isEmpty(tipData.netdeviceName) ? `<tr><th>장비명</th><td>${tipData.netdeviceName}</td></tr>` : ''}
                ${!isEmpty(tipData.ipaddress) ? `<tr><th>장비IP</th><td>${tipData.ipaddress}</td></tr>` : ''}
                ${!isEmpty(tipData.speed) ? `<tr><th>대역폭</th><td>${convertValuByUnit(tipData.speed, 'bps', false, false, true)}</td></tr>` : ''}
              </table>
            </div>
            %PERFORMANCE%
            %MEMO%
          </div>
        </div>
      </div>
    `;
  }
  return tipText;
}

/**
 * 가상서버 (호스트 클러스터) 툴팁
 * @author {name}
 * @param  {[type]} tipData [description]
 */
function setVclToolTipText(tipData) {
  const tipText = `
  <div class="object-tooltip">
    <div class="inner-contents">
      <div class="tooltip-header">
        <label class="name">${tipData.objName}</label>
      </div>
      <div class="tooltip-content">
        <div class="object_info">
          <table>
            <colgroup>
              <col width="40%">
              <col width="60%">
            </colgroup>
            ${!isEmpty(tipData.hypervisorType) ? `<tr><th>가상화 벤더</th><td>${tipData.hypervisorType}</td></tr>` : ''}
            ${!isEmpty(tipData.vmsObjType) ? `<tr><th>장비 종류</th><td>${tipData.vmsObjType}</td></tr>` : ''}
            ${!isEmpty(tipData.drsMode) ? `<tr><th>DRS 모드</th><td>${tipData.drsMode}</td></tr>` : ''}
            ${!isEmpty(tipData.haMode) ? `<tr><th>HA 모드</th><td>${tipData.haMode}</td></tr>` : ''}
          </table>
        </div>
        <div class="object_info" style="margin-top: 10px;">
          <table>
            <colgroup>
              <col width="40%">
              <col width="60%">
            </colgroup>
            ${!isEmpty(tipData.vhoCount) ? `<tr><th>호스트 수</th><td>${tipData.vhoCount}</td></tr>` : ''}
            ${!isEmpty(tipData.processorCount) ? `<tr><th>총 프로세서 수</th><td>${tipData.processorCount}</td></tr>` : ''}
            ${!isEmpty(tipData.vdscCount) ? `<tr><th>스토리지 클러스터 수</th><td>${tipData.vdscCount}</td></tr>` : ''}
            ${!isEmpty(tipData.vdsCount) ? `<tr><th>스토리지 수</th><td>${tipData.vdsCount}</td></tr>` : ''}
          </table>
        </div>
      </div>
      %PERFORMANCE%
      %MEMO%
    </div>
  </div>
  `;
  return tipText;
}

/**
 * 가상서버 (호스트) 툴팁
 * @author {name}
 * @param  {[type]} tipData [description]
 */
function setVhoToolTipText(tipData) {
  const tipText = `
  <div class="object-tooltip">
    <div class="inner-contents">
      <div class="tooltip-header">
        <label class="name">${tipData.objName}</label>
      </div>
      <div class="tooltip-content">
        <div class="object_info">
          <table>
            <colgroup>
              <col width="40%">
              <col width="60%">
            </colgroup>
            ${!isEmpty(tipData.hypervisorType) ? `<tr><th>가상화 벤더</th><td>${tipData.hypervisorType}</td></tr>` : ''}
            ${!isEmpty(tipData.vmsObjType) ? `<tr><th>장비 종류</th><td>${tipData.vmsObjType}</td></tr>` : ''}
            ${!isEmpty(tipData.model) ? `<tr><th>모델</th><td>${tipData.model}</td></tr>` : ''}
            ${!isEmpty(tipData.ipaddress) ? `<tr><th>IP</th><td>${tipData.ipaddress}</td></tr>` : ''}
          </table>
        </div>
        <div class="object_info" style="margin-top: 10px;">
          <table>
            <colgroup>
              <col width="40%">
              <col width="60%">
            </colgroup>
            ${!isEmpty(tipData.vvmCount) ? `<tr><th>VM 수</th><td>${tipData.vvmCount}</td></tr>` : ''}
            ${!isEmpty(tipData.cpuCoreCount) ? `<tr><th>CPU 코어</th><td>${tipData.cpuCoreCount}</td></tr>` : ''}
            ${!isEmpty(tipData.haMode) ? `<tr><th>HA 모드</th><td>${tipData.haMode}</td></tr>` : ''}
            ${!isEmpty(tipData.bootTime) ? `<tr><th>기동시각</th><td>${tipData.bootTime}<br />(${calcUptime(new Date(tipData.bootTime), new Date())})</td></tr>` : ''}
          </table>
        </div>
      </div>
      %PERFORMANCE%
      %MEMO%
    </div>
  </div>
  `;
  return tipText;
}

/**
 * 가상서버 VM 툴팁
 * @author {name}
 * @param  {[type]} tipData [description]
 */
function setVvmToolTipText(tipData) {
  const tipText = `
  <div class="object-tooltip">
    <div class="inner-contents">
      <div class="tooltip-header">
        <label class="name">${tipData.objName}</label>
      </div>
      <div class="tooltip-content">
        <div class="object_info">
          <table>
            <colgroup>
              <col width="40%">
              <col width="60%">
            </colgroup>
            ${!isEmpty(tipData.hypervisorType) ? `<tr><th>가상화 벤더</th><td>${tipData.hypervisorType}</td></tr>` : ''}
            ${!isEmpty(tipData.vmsObjType) ? `<tr><th>장비 종류</th><td>${tipData.vmsObjType}</td></tr>` : ''}
            ${!isEmpty(tipData.ipaddress) ? `<tr><th>IP</th><td>${tipData.ipaddress}</td></tr>` : ''}
          </table>
        </div>
        <div class="object_info" style="margin-top: 10px;">
          <table>
            <colgroup>
              <col width="40%">
              <col width="60%">
            </colgroup>
            ${!isEmpty(tipData.parentIpaddress) ? `<tr><th>호스트 IP</th><td>${tipData.parentIpaddress}</td></tr>` : ''}
            ${!isEmpty(tipData.alive) ? `<tr><th>VM 상태</th><td>${tipData.alive}</td></tr>` : ''}
            ${!isEmpty(tipData.os) ? `<tr><th>운영체제</th><td>${tipData.os}</td></tr>` : ''}
            ${!isEmpty(tipData.bootTime) ? `<tr><th>기동시각</th><td>${tipData.bootTime}<br />(${calcUptime(new Date(tipData.bootTime), new Date())})</td></tr>` : ''}
          </table>
        </div>
      </div>
      %PERFORMANCE%
      %MEMO%
    </div>
  </div>
  `;
  return tipText;
}

/**
 * 가상서버 (스토리지 클러스터) 툴팁
 * @author {name}
 * @param  {[type]} tipData [description]
 */
function setVdscToolTipText(tipData) {
  const tipText = `
  <div class="object-tooltip">
    <div class="inner-contents">
      <div class="tooltip-header">
        <label class="name">${tipData.objName}</label>
      </div>
      <div class="tooltip-content">
        <div class="object_info">
          <table>
            <colgroup>
              <col width="40%">
              <col width="60%">
            </colgroup>
            ${!isEmpty(tipData.hypervisorType) ? `<tr><th>가상화 벤더</th><td>${tipData.hypervisorType}</td></tr>` : ''}
            ${!isEmpty(tipData.vmsObjType) ? `<tr><th>장비 종류</th><td>${tipData.vmsObjType}</td></tr>` : ''}
            ${!isEmpty(tipData.type) ? `<tr><th>유형</th><td>${tipData.type}</td></tr>` : ''}
            ${!isEmpty(tipData.totalCapacity) ? `<tr><th>총 용량</th><td>${convertValuByUnit(Number(tipData.totalCapacity), 'MB', true, false, true)}B</td></tr>` : ''}

          </table>
        </div>
        <div class="object_info" style="margin-top: 10px;">
          <table>
            <colgroup>
              <col width="40%">
              <col width="60%">
            </colgroup>
            ${!isEmpty(tipData.vdsCount) ? `<tr><th>스토리지 수</th><td>${tipData.vdsCount}</td></tr>` : ''}
            ${!isEmpty(tipData.vvmCount) ? `<tr><th>VM 수</th><td>${tipData.vvmCount}</td></tr>` : ''}
            ${!isEmpty(tipData.snapshotCount) ? `<tr><th>스냅샷 수</th><td>${tipData.snapshotCount}</td></tr>` : ''}
          </table>
        </div>
      </div>
      %PERFORMANCE%
      %MEMO%
    </div>
  </div>
  `;
  return tipText;
}

/**
 * 가상서버 (스토리지) 툴팁
 * @author {name}
 * @param  {[type]} tipData [description]
 */
function setVdsToolTipText(tipData) {
  const tipText = `
  <div class="object-tooltip">
    <div class="inner-contents">
      <div class="tooltip-header">
        <label class="name">${tipData.objName}</label>
      </div>
      <div class="tooltip-content">
        <div class="object_info">
          <table>
            <colgroup>
              <col width="40%">
              <col width="60%">
            </colgroup>
            ${!isEmpty(tipData.hypervisorType) ? `<tr><th>가상화 벤더</th><td>${tipData.hypervisorType}</td></tr>` : ''}
            ${!isEmpty(tipData.vmsObjType) ? `<tr><th>장비 종류</th><td>${tipData.vmsObjType}</td></tr>` : ''}
            ${!isEmpty(tipData.type) ? `<tr><th>유형</th><td>${tipData.type}</td></tr>` : ''}
            ${!isEmpty(tipData.totalCapacity) ? `<tr><th>총 용량</th><td>${convertValuByUnit(Number(tipData.totalCapacity), 'MB', true, false, true)}B</td></tr>` : ''}

          </table>
        </div>
        <div class="object_info" style="margin-top: 10px;">
          <table>
            <colgroup>
              <col width="40%">
              <col width="60%">
            </colgroup>
            ${!isEmpty(tipData.vhoCount) ? `<tr><th>호스트 수</th><td>${tipData.vhoCount}</td></tr>` : ''}
            ${!isEmpty(tipData.vvmCount) ? `<tr><th>VM / 템플릿 수</th><td>${tipData.vvmCount} / ${tipData.templateCount}</td></tr>` : ''}
          </table>
        </div>
      </div>
      %PERFORMANCE%
      %MEMO%
    </div>
  </div>
  `;
  return tipText;
}

/**
 * 자동맵 (연결장비)의 툴팁에 표현할 Sub Ip를 반환한다.
 * @author {name}
 * @param  {[type]} tipData [description]
 * @return {[type]}         [description]
 */
function getConnectionDeviceIp(tipData) {
  let tipText = '';

  if (tipData.subIps) {
    let subIpText = '';
    const subIpSplit = tipData.subIps.split(',');
    forEach(subIpSplit, (ip) => {
      const subIp = ip.trim();
      if (subIp !== tipData.ipaddress) {
        subIpText += `<br/><span class="tooltip-sub-ip">${subIp}</span>`;
      }
    });
    tipText = `
      <b>${tipData.ipaddress}</b>
      ${subIpText}
    `;
  } else {
    tipText = tipData.ipaddress;
  }

  return tipText;
}
/**
 * 자동맵 (연결장비) 툴팁
 * @author {name}
 * @param  {[type]} tipData [description]
 */
function setConnectionDeviceToolTipText(tipData) {
  const tipText = `
  <div class="object-tooltip">
    <div class="inner-contents">
      <div class="tooltip-header">
        <label class="name">${tipData.deviceName || tipData.ipaddress || '-'}</label>
      </div>
      <div class="tooltip-content">
        <div class="object_info">
          <table>
            <colgroup>
              <col width="40%">
              <col width="60%">
            </colgroup>
            ${!isEmpty(tipData.objtypeName) ? `<tr><th>장비 종류</th><td>${tipData.objtypeName}</td></tr>` : ''}
            ${!isEmpty(tipData.companyName) ? `<tr><th>제조사</th><td>${tipData.companyName}</td></tr>` : ''}
            ${!isEmpty(tipData.ipaddress) ? `<tr><th>IP</th><td>${getConnectionDeviceIp(tipData)}</td></tr>` : ''}
            ${!isEmpty(tipData.macaddress) ? `<tr><th>MAC</th><td>${tipData.macaddress}</td></tr>` : ''}
            ${!isEmpty(tipData.deviceDesc) ? `<tr><th>설명</th><td>${tipData.deviceDesc}</td></tr>` : ''}
          </table>
        </div>
      </div>
      %PERFORMANCE%
      %MEMO%
    </div>
  </div>
  `;
  return tipText;
}

/**
 * 툴팁 부가 내용 추가
 * @author {name}
 * @param  {[type]} tipText [description]
 * @param  {[type]} tipData [description]
 * @param  {[type]} target  [description]
 */
function setExtraToolTipText(tipText, tipData, target) {
  const performance = `
  <div class="object_info" style="margin-top: 10px;">
    <table>
      <colgroup>
        <col width="40%">
        <col width="60%">
      </colgroup>
      ${!isEmpty(target['value3.name']) ? `<tr><th>${target['value3.name']}</th><td>${target['value3.value']}</td></tr>` : ''}
      ${!isEmpty(target['value1.name']) ? `<tr><th>${target['value1.name']}</th><td>${target['value1.value']}</td></tr>` : ''}
      ${!isEmpty(target['value2.name']) ? `<tr><th>${target['value2.name']}</th><td>${target['value2.value']}</td></tr>` : ''}
    </table>
  </div>
  `;


  let statusComment = '';
  if (tipData.statusComment) {
    statusComment = tipData.statusComment.length > 100 ? `${tipData.statusComment.substr(0, 100)}...` : tipData.statusComment;
    statusComment = statusComment.replace(/\n/g, '<br/>');
  }
  const memo = `
  <div class="object_info" style="margin-top: 10px;">
    <table>
      <colgroup>
        <col width="40%">
        <col width="60%">
      </colgroup>
      ${`<tr><th>메모</th><td>${statusComment}</td></tr>`}
    </table>
  </div>
  `;

  let tip = tipText;

  // 성능
  if (!isEmpty(target['value1.name']) || !isEmpty(target['value2.name']) || !isEmpty(target['value3.name'])) {
    tip = tip.replace('%PERFORMANCE%', performance);
  } else {
    tip = tip.replace('%PERFORMANCE%', '');
  }

  // 메모
  if (tipData.statusComment) {
    tip = tip.replace('%MEMO%', memo);
  } else {
    tip = tip.replace('%MEMO%', '');
  }

  return tip;
}

/**
 * 토폴로지맵 오브젝트 툴팁 생성
 * @author {name}
 * @param  {[type]} tipData         [description]
 * @param  {[type]} target          [description]
 * @param  {[type]} objManagetypeId [description]
 * @param  {[type]} objDefineId     [description]
 * @return {[type]}                 [description]
 */
export function makeTooltip(tipData, target, objManagetypeId, objDefineId) {
  let tooltip = '';
  if (target instanceof Q.LanModel) {
    tooltip = setLanModelToolTipText(tipData, target);
  } else if (target instanceof Q.ManagedObjectModel) {
    if (!objManagetypeId) { // 연결장비..
      tooltip = setConnectionDeviceToolTipText(tipData, target);
    } if (objManagetypeId === 'SMS' || objManagetypeId === 'DBMS') {
      tooltip = setCommonToolTipText(tipData, target);
    } else if (objManagetypeId === 'NMS') {
      tooltip = setNmsToolTipText(tipData, target);
    } else if (objManagetypeId === 'FMS') {
      tooltip = setFmsToolTipText(tipData, target);
    } else if (objManagetypeId === 'APM') {
      // 미사용
    } else if (objManagetypeId === 'BMS') {
      // 미사용
    } else if (objManagetypeId === 'E2E') {
      // 미사용
    } else if (objManagetypeId === 'VMS') {
      if (objDefineId === 'VCL') {
        tooltip = setVclToolTipText(tipData, target);
      } else if (objDefineId === 'VHO') {
        tooltip = setVhoToolTipText(tipData, target);
      } else if (objDefineId === 'VVM') {
        tooltip = setVvmToolTipText(tipData, target);
      } else if (objDefineId === 'VDSC') {
        tooltip = setVdscToolTipText(tipData, target);
      } else if (objDefineId === 'VDS') {
        tooltip = setVdsToolTipText(tipData, target);
      }
    } else {
      // 미사용
    }
  }
  tooltip = setExtraToolTipText(tooltip, tipData, target);

  return tooltip.replace(/\r?\n|\r/g, '');
}
/* eslint-enable import/prefer-default-export, max-len, no-void */



// WEBPACK FOOTER //
// ./src/views/topologymap/js/tooltip.js